module.exports = __webpack_public_path__ + "static/media/素雞卷.f966700b.jpg";